import InteractionEvent, {
  type InteractionTargetType
} from './InteractionEvent';

export type SortTargetProperties = {
  filters?: { key: string; value: string }[];
  selected_sort_key: string;
  sort_key: string;
};

type EventData = {
  filters?: { key: string; value: string }[];
  gesture?: string;
  guestId?: string;
  isBot: boolean;
  selectedSortKey: string;
  sortKey: string;
};

class SortInteractionEvent extends InteractionEvent<
  EventData,
  SortTargetProperties
> {
  protected get targetType(): InteractionTargetType {
    return 'sort';
  }

  protected getTargetProperties(): SortTargetProperties {
    return {
      filters: this.data.filters,
      selected_sort_key: this.data.selectedSortKey,
      sort_key: this.data.sortKey
    };
  }
}

export default SortInteractionEvent;
